// src/pages/RegionalPackagesPage.js
//
// Bölgesel eSIM paketleri: standart ailenin ülke dışı (bölgesel + global)
// bundle'ları. Ömürlükler kendi sayfasında, ülke paketleri eSIM Paketleri'nde.
import React from 'react';
import ContinentPackages from '../components/catalog/ContinentPackages';

// Bileşen dışında: her render'da yeni fonksiyon, listeyi her seferinde yeniden çektirirdi.
const isNotCountryBundle = (bundle) => bundle.scope !== 'country';

const RegionalPackagesPage = () => (
    <ContinentPackages
        family="standard"
        includeBundle={isNotCountryBundle}
        title="Bölgesel eSIM Paketleri"
        subtitle="Bölge bazlı paketlerin fiyatlarını, mağaza durumlarını ve yayınını yönetin."
    />
);

export default RegionalPackagesPage;
